import { createAction } from 'redux-actions';
import { createActionBundle } from 'utilities/request';

export const {
  request: requestGetPatientStatusesById,
  success: requestGetPatientStatusesByIdSuccess,
  failure: requestGetPatientStatusesByIdFailure,
} = createActionBundle('GET_PATIENT_STATUSES_BY_ID');

export const patientEngagementSetStatusesWithPatientId = createAction(
  'PATIENT_ENGAGEMENT/SET_STATUSES_WITH_PATIENT_ID',
);

export const patientEngagementInitStatusesPage = createAction(
  'PATIENT_ENGAGEMENT/INIT_STATUSES_PAGE',
);

export const patientEngagementSortTable = createAction('PATIENT_ENGAGEMENT/SORT_TABLE');
